module.exports = __webpack_public_path__ + "img/Weapon_12.a6102545.png";